mutation RequestMaterialUploadUrl($input: RequestMaterialUploadUrlInput!) {
  requestMaterialUploadUrl(input: $input) {
    uploadUrl
    s3Key
    expiresAt
  }
}
